import { render, staticRenderFns } from "./starLeft.vue?vue&type=template&id=004d0649&scoped=true"
import script from "./starLeft.vue?vue&type=script&lang=js"
export * from "./starLeft.vue?vue&type=script&lang=js"
import style0 from "./starLeft.vue?vue&type=style&index=0&id=004d0649&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d0649",
  null
  
)

export default component.exports